import type { PayloadAction } from "@reduxjs/toolkit";
import { Languages } from "Data/Objects/Languages";
import { createAppSlice } from "Data/Redux/Store";
import type { UserSettingsState } from "Interfaces";

const initialState: UserSettingsState = {
	selectedLanguage: Languages.ENGLISH,
	navbarCollapsed: false,
	needsPassword: true
};

export const changeLanguageReducer = (state: UserSettingsState, action: PayloadAction<Languages>) => {
	state.selectedLanguage = action.payload;
};

export const setNavbarCollapsedReducer = (state: UserSettingsState, action: PayloadAction<boolean>) => {
	state.navbarCollapsed = action.payload;
};

export const setNeedsPasswordReducer = (state: UserSettingsState, action: PayloadAction<boolean>) => {
	state.needsPassword = action.payload;
};

export const getSelectedLanguage = (state: UserSettingsState) => {
	return state.selectedLanguage;
};

export const getNavbarCollapsed = (state: UserSettingsState) => {
	return state.navbarCollapsed;
};

export const getNeedsPassword = (state: UserSettingsState) => {
	return state.needsPassword;
};

const userSettingsSlice = createAppSlice({
	name: "userSettings",
	initialState,
	reducers: (create) => ({
		changeLanguageAction: create.reducer(changeLanguageReducer),
		setNavbarCollapsedAction: create.reducer(setNavbarCollapsedReducer),
		setNeedsPasswordAction: create.reducer(setNeedsPasswordReducer)
	}),
	selectors: {
		selectSelectedLanguage: getSelectedLanguage,
		selectNavbarCollapsed: getNavbarCollapsed,
		selectNeedsPassword: getNeedsPassword
	}
});

export default userSettingsSlice;

export const { changeLanguageAction, setNavbarCollapsedAction, setNeedsPasswordAction } = userSettingsSlice.actions;
export const { selectSelectedLanguage, selectNavbarCollapsed, selectNeedsPassword } = userSettingsSlice.selectors;
